module.exports = __webpack_public_path__ + "static/media/all_ideas.22b2c093.txt";